export type ApiRequestMeta = {
  background?: boolean;
  skipGlobalErrorToast?: boolean;
  /** Force network fetch, bypassing IndexedDB cache. */
  skipCache?: boolean;
  /** Per-request timeout override (ms). */
  timeout?: number;
};

export type ApiMetaArg = {
  meta?: ApiRequestMeta;
};

export function bgMeta(silent?: boolean): ApiMetaArg | undefined {
  return silent ? { meta: { background: true } } : undefined;
}

/** @deprecated Use bgMeta with RTK Query args */
export function bgIf(silent: boolean): ApiRequestMeta | undefined {
  return silent ? { background: true } : undefined;
}
